import Layout from "@/layout/Layout";
import globalStyle from '@/styles/Global.scss'
import React, {useEffect, useState} from "react";
import {Schedule} from "@/entity/Schedule";
import {useHistory, useParams} from "react-router";
import {addSchedule} from "@/api/schedule";
import MButton from "@/components/atom/MButton";
import {Form} from "react-bootstrap";
import dayjs from "dayjs";

const AddSchedule = () => {
  const history = useHistory()
  const {date} = useParams()
  const [schedule, setSchedule] = useState(new Schedule({}))

  useEffect(() => {
    const day = dayjs(date, 'YYYYMMDD')
    if (!day.isValid()) {
      return
    }
    const schedule = new Schedule({date: day.toDate()})
    setSchedule(schedule)
  }, [date])

  const add = async () => {
    await addSchedule({schedule})
    history.push(`/schedule`)
  }

  const back = () => {
    history.push(`/schedule`)
  }

  return (
    <>
      <Layout category={'WA'} title={'スケジュール登録'}>
        <div className={globalStyle.container}>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>日付</Form.Label>
              <Form.Control type="date" value={schedule.formatedDate()} onChange={(e) => setSchedule(new Schedule({...schedule, date: e.target.value }))} placeholder="日付を入力してください。" />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>営業日</Form.Label>
              <Form.Select value={schedule.holiday} aria-label="営業日" onChange={(e) => setSchedule(new Schedule({...schedule, holiday: e.target.value}))}>
                <option value={'false'}>営業日</option>
                <option value={'true'}>休業日</option>
              </Form.Select>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>営業時間</Form.Label>
              <Form.Control type="text" value={schedule.businessHour} onChange={(e) => setSchedule(new Schedule({...schedule, businessHour: e.target.value }))} placeholder="営業時間を入力してください。" />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>メモ</Form.Label>
              <Form.Control as="textarea" value={schedule.memo} onChange={(e) => setSchedule(new Schedule({...schedule, memo: e.target.value }))} placeholder="メモを入力してください。" />
            </Form.Group>
          </Form>
          <MButton image={'touroku.png'} value={'登録'} onClick={add}></MButton>
          <MButton image={'back.png'} value={'戻る'} onClick={back}></MButton>
        </div>
      </Layout>
    </>
  )
}

export default AddSchedule
